<template>
  <div class="colorPicker">
    <v-swatches
      @input="input"
      v-model="selectedColor"
      inline
      :swatches="swatches"
      :row-length="5"
      :show-border="true"
    ></v-swatches>
  </div>
</template>

<script>
import VSwatches from "vue-swatches";

// Import the styles too, typically in App.vue or main.js
import "vue-swatches/dist/vue-swatches.css";

export default {
  components: { VSwatches },
  props: {
    color: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedColor: "#FFFFFF",
      swatches: [
        "#FFFFFF",
        "#262626",
        "#000000",
        "#1ebc9b",
        "#2dcc70",
        "#3297db",
        "#297fb8",
        "#a463bf",
        "#f2c510",
        "#f39c19",
        "#e84b3c"
      ]
    };
  },
  methods: {
    input(color) {
      this.$emit("input", color);
    }
  },
  mounted() {
    if (this.color && this.color !== "") {
      this.selectedColor = this.color
        .replace("background-color: ", "")
        .replace(";color: #fff", "");
    }
  }
};
</script>
